import React from 'react'
import Flex from 'typescript-styled-flex'
import logoBedBooking from '../../assets/bb-logo-big.png'
import { theme } from '../../theme'

function DateError() {
  return (
    <Flex
      full={true}
      center={true}
      column={true}
      style={{ height: 'var(--full)', minHeight: 'var(--full)' }}
    >
      <img style={{ width: '50%' }} alt={'BedBooking'} src={logoBedBooking} />
      <div
        style={{
          color: theme.colors.palette.reddish,
          fontSize: '30px',
          fontWeight: 500,
          opacity: 0.6,
        }}
      >
        DATE ERROR;
      </div>
      <div
        style={{
          color: theme.colors.palette.darkGreyTwo,
          fontSize: '20px',
          opacity: 0.7,
        }}
      >
        Please check the system settings.
      </div>
    </Flex>
  )
}

export default DateError
